import React from 'react';

// Grille affichant tous les joueurs ainsi que le panneau interactif du joueur actif
const PlayersGrid = ({
  players,
  currentPlayerIndex,
  winner,
  renderCurrentPanel
}) => (
  <div className="players-grid">
    {players.map((player, index) => (
      <div
        key={player.id}
        className={`player-section ${index === currentPlayerIndex ? 'current-player' : ''}`}
      >
        <div className="player-name">
          {player.name}
          {index === currentPlayerIndex && <span> (Joueur actuel)</span>}
        </div>
        <div className="player-score">{player.score}</div>

        {index === currentPlayerIndex && !winner && renderCurrentPanel()}
      </div>
    ))}
  </div>
);

export default PlayersGrid;

